import { ACTIVE_WORKSPACE_POSTION_ID } from "../constants/Workspace";

/**
 * @format
 */
export const setActiveWorkspacePositionId = ( position_id) =>
  localStorage.setItem(ACTIVE_WORKSPACE_POSTION_ID, position_id);
